<template>
  <div class="rootDiv">
    <Navbar v-model="selectedSort" style="background-color: #e5debd">
      <TabItem :id=3 v-on:click.native="GetJokeList(false)"><span style="font-size: 1.2rem">随机</span></TabItem>
      <TabItem :id=2 v-on:click.native="GetJokeList(false)"><span style="font-size: 1.2rem">最开心</span></TabItem>
    </Navbar>
    <Navbar v-model="selectedType">
      <TabItem :id=1 v-on:click.native="GetJokeList(false)"><span style="font-size: 0.8rem">图文笑话</span></TabItem>
      <TabItem :id=2 v-on:click.native="GetJokeList(false)"><span style="font-size: 0.8rem">文字笑话</span></TabItem>
    </Navbar>
    <div :style="classtest">
      <Loadmore :top-method="loadTop" :bottom-method="loadBottom" :auto-fill="false" ref="loadmore">
        <div v-for="item in JokeList" :key="item.xHNM"
             style="border-top: green 2px solid;border-left: green 1px solid;border-right: green 1px solid;">
          <div :style="{'padding': selectedType===1?'0':'5px'}">
            <img :src="item.tPDZ" v-show="selectedType===1" alt="" :width="width">
            <div v-html="item.nR" :style="{'text-align': selectedType===1?'center':'left'}"></div>
          </div>
          <div style="text-align: right;padding-top: 2px;padding-bottom:2px;border-top: solid 1px gray">
            <div style="float: left;margin-top: 8px">
              <span style="font-size: 0.9rem">{{ item.tJSJ }}</span>
            </div>
            <!--            <div style="float: right;margin-top: 8px;margin-right: 10px">
                          <span style="font-size: 0.9rem">{{ item.pLSL }}</span>
                        </div>
                        <div style="float: right;margin-right: 2px">
                          <img src="../../../assets/images/32/comment.png" alt=""
                               style="width: 28px;height: 28px">
                        </div>-->
            <div style="float: right;margin-top: 8px;margin-right: 10px">
              <span style="font-size: 0.9rem">{{ item.sCSL }}</span>
            </div>
            <div style="float: right;margin-right: 2px">
              <img v-if="item.sC>0" src="../../../assets/images/32/collected.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'2',true)">
              <img v-else src="../../../assets/images/32/collection.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'2',false)">
            </div>
            <div style="float: right;margin-top: 8px;margin-right: 10px">
              <span style="font-size: 0.9rem">{{ item.dCSL }}</span>
            </div>
            <div style="float: right;margin-right: 2px">
              <img v-if="item.dC>0" src="../../../assets/images/32/not_liked.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'1',true)">
              <img v-else src="../../../assets/images/32/not_like.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'1',false)">

            </div>
            <div style="float: right;margin-top: 8px;margin-right: 10px">
              <span style="font-size: 0.9rem">{{ item.dZSL }}</span>
            </div>
            <div style="float: right;margin-right: 2px">
              <img v-if="item.dZ>0" src="../../../assets/images/32/liked.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'0',true)">
              <img v-else src="../../../assets/images/32/like.png" alt=""
                   style="width: 28px;height: 28px"
                   @click="UserAction(item.xHNM,'0',false)">
            </div>
            <div style="clear: both"></div>
          </div>
        </div>
      </Loadmore>
    </div>
    <div>
      <span v-if="noMore">没有更多了...</span>
    </div>
  </div>
</template>

<script>
import {Navbar, TabItem, Loadmore, Indicator} from 'mint-ui';

export default {
  name: "Joke",
  components: {
    Navbar, TabItem, Loadmore
  },
  data() {
    return {
      noMore: false,
      width: document.documentElement.clientWidth - 5,
      selectedSort: 3,
      selectedType: 1,
      JokeList: [],
      pageSize: 30,
      pageIndex: 1,
      Joke: {
        xHNM: null,
        tPDZ: null,
        nR: null,
        tJSJ: null,
        dZ: 0,
        dC: 0,
        sC: 0,
        dZSL: 0,
        dCSL: 0,
        sCSL: 0,
        pLSL: 0,
      },
      yhnm: localStorage.getItem('yhnm'),
      token: localStorage.getItem('token'),
      getJokeListUrl: '/api/joke/getJokeList',
      likeAndCollectUrl: '/api/joke/likeAndCollect',
      classtest:
          {
            overflow: 'scroll',
            height: (document.documentElement.clientHeight - 60).toString() + 'px',
          },
    }
  },
  watch: {
    selectedSort: function (val, oldVal) {
      if (val !== oldVal)
        this.pageIndex = 1
    },
    selectedType: function (val, oldVal) {
      if (val !== oldVal)
        this.pageIndex = 1
    },
  },
  mounted() {
    this.GetJokeList(false)
  },
  methods: {
    UserAction(xhnm, action, isCancel) {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.likeAndCollectUrl,
        params: {yhnm: that.yhnm, xhnm: xhnm, action: action, isCancel: isCancel},
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          for (let i = 0; i < that.JokeList.length; i++) {
            if (that.JokeList[i].xHNM === xhnm) {
              let num = 1
              if (isCancel)
                num = -1
              if (action === '0') {
                that.JokeList[i].dZ = num
                that.JokeList[i].dZSL = that.JokeList[i].dZSL + num
                if (num === 1 && that.JokeList[i].dC > 0) {
                  that.JokeList[i].dC = -1
                  that.JokeList[i].dCSL = that.JokeList[i].dCSL - 1
                }
              } else if (action === '1') {
                that.JokeList[i].dC = num
                that.JokeList[i].dCSL = that.JokeList[i].dCSL + num
                if (num === 1 && that.JokeList[i].dZ > 0) {
                  that.JokeList[i].dZ = -1
                  that.JokeList[i].dZSL = that.JokeList[i].dZSL - 1
                }
              } else {
                that.JokeList[i].sC = num
                that.JokeList[i].sCSL = that.JokeList[i].sCSL + num
              }
              break
            }
          }
        }
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
    loadTop() {
      let that = this
      that.pageIndex = 1
      that.GetJokeList(false)
      that.$refs.loadmore.onTopLoaded();
    },
    loadBottom() {
      if (this.noMore === true) {
        this.$refs.loadmore.onBottomLoaded();
        return;
      }
      this.GetJokeList(true)
    },
    GetJokeList(isLoadmore) {
      Indicator.open({
        text: '数据加载中...',
        spinnerType: 'fading-circle'
      });
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getJokeListUrl,
        params: {
          yhnm: that.yhnm,
          pageIndex: that.pageIndex,
          pageSize: that.pageSize,
          type: that.selectedType,
          sort: that.selectedSort
        },
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        Indicator.close();
        if (!response.data.result)
          that.$messagebox.alert(response.data.message)
        else {
          let responseData = response.data['responseData']
          let list = responseData['data']
          if (that.pageIndex === 1) {
            that.JokeList = list
          } else {
            that.JokeList = that.JokeList.concat(list)
          }
          let isLast = responseData['isLast'].toString() !== 'false';
          if (!isLast) {
            that.pageIndex++
            that.noMore = false
          } else {
            that.noMore = true
          }
        }
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      }).catch(response => {
        Indicator.close();
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
        if (isLoadmore)
          that.$refs.loadmore.onBottomLoaded();
      })
    },
  }
}
</script>

<style lang="less" scoped>
.rootDiv {
  margin: -0.5rem;

  .mint-navbar .mint-tab-item.is-selected {
    margin-bottom: 0;
  }
}

.containerclass {

}

/deep/ .mint-tab-item {
  padding: 8px 0;
}
</style>
